import { useTranslation } from 'react-i18next'
import { NS } from '~/enums'
import { Pagination as ArkPagination, type PaginationRootProps as ArkPaginationRootProps } from '@ark-ui/react'
import { classNames as cn } from '~/helpers/string'
import Button from '~/components/shared/Button'
import { ArrowLeftIcon } from '~/components/icons/ArrowLeftIcon'
import { ArrowRightIcon } from '~/components/icons/ArrowRightIcon'

export type PaginationProps = {
  className?: string
} & ArkPaginationRootProps

export function Pagination(props: PaginationProps) {
  const { page: currentPage, siblingCount = 0, className = '', ...rest } = props
  let { t } = useTranslation()

  let previousPage = t('previous', { ns: NS.GLOBALS })
  let nextPage = t('next', { ns: NS.GLOBALS })

  return (
    <ArkPagination.Root
      page={currentPage}
      siblingCount={siblingCount}
      className={cn('flex flex-row gap-1 lg:gap-2', className)}
      {...rest}
    >
      <ArkPagination.PrevTrigger asChild>
        <Button aria-label={previousPage} variant="text" color="secondary" className="!px-2 disabled:hidden">
          <ArrowLeftIcon />
        </Button>
      </ArkPagination.PrevTrigger>
      <ArkPagination.Context>
        {(pagination) =>
          pagination.pages.map((page, index) =>
            page.type === 'page' ? (
              <ArkPagination.Item key={index} asChild {...page}>
                <Button variant={page.value === currentPage ? 'filled' : 'text'} color="secondary" className="!px-4">
                  {page.value}
                </Button>
              </ArkPagination.Item>
            ) : (
              <ArkPagination.Ellipsis key={index} index={index} asChild>
                <Button variant="text" className="cursor-auto !px-2 hover:bg-white active:bg-white lg:!px-4">
                  &#8230;
                </Button>
              </ArkPagination.Ellipsis>
            ),
          )
        }
      </ArkPagination.Context>
      <ArkPagination.NextTrigger asChild>
        <Button aria-label={nextPage} variant="text" color="secondary" className="!px-2 disabled:hidden">
          <ArrowRightIcon />
        </Button>
      </ArkPagination.NextTrigger>
    </ArkPagination.Root>
  )
}
